import React from 'react'
import GeneralCalendarPage from './GeneralCalendar'

const CalendarAgendaView: any = () => {
  return <GeneralCalendarPage defaultCurrentView={'agenda'} initialView={'agendaView'} isDefaultViewAgenda={true} />
}

export default CalendarAgendaView
